const pt = {
  nav: { historia: "História", carta: "Carta", vision: "Visão", servicios: "Outros serviços", galeria: "Galeria", mapa: "Mapa web", cta: "Pedir informação" },
  services: { cumpleanos: "Aniversários", fiestas: "Festas privadas", reservas: "Reservas do espaço", info: "Informação geral" },
  hero: {
    eyebrow: "Cozinha de autor · Coquetelaria premium · Desde sempre",
    l1: "El gato", l2: "con copas",
    claim: "Não é uma noite. É uma experiência.",
    sub: "O bar de sempre, o dos nossos. Aqui conhecemo-nos, aqui começou tudo e aqui continuamos a misturar o antídoto: bons cocktails, melhor companhia e noites que não se repetem.",
    cta: "Reserva a tua noite", cta2: "Ver a carta", badge: "Sete vidas, uma noite",
  },
  marquee: ["Não é uma noite, é uma experiência", "O bar de sempre", "Cocktails de autor", "Aqui começou tudo", "Aniversários", "Festas privadas", "Reserva o espaço", "Sete vidas, mil copos"],
  historia: {
    eyebrow: "A nossa história",
    title: "Onde começou o fio vermelho",
    lead: "Todas as boas histórias têm um bar. A nossa tem este.",
    scenes: [
      { y: "2022", t: "Duas vidas, um balcão por chegar", d: "Ele vinha da hotelaria e do turismo do Mediterrâneo, de longas temporadas atrás do balcão. Ela, dos números, da empresa e da logística, à procura de algo que a preenchesse de verdade. Caminhos separados, uma faísca em comum: a criatividade." },
      { y: "2023", t: "O fio vermelho", d: "Numa noite qualquer, neste balcão, o destino cruzou os nossos caminhos. Aqui conhecemo-nos. Entre copos e conversa começámos a tecer um fio vermelho que, sem sabermos, seria o alicerce de tudo o que veio depois." },
      { y: "2023–2024", t: "A receita", d: "Voltávamos sem combinar, porque este era o nosso sítio. E aqui, entre risos e balcão, encontrámos o antídoto: boa gente, um copo bem feito, música que fica no ouvido e nenhuma pressa de sair. A receita da nossa felicidade. Dessas noites nasceram a #PICHONTEAM e as primeiras marcas que criámos juntos." },
      { y: "2025", t: "O duplo salto mortal", d: "Reinventámo-nos de cima a baixo e tornámo-nos sócios de um projeto partilhado. Não foi fácil, mas fortaleceu-nos. Continuamos no ofício e continuamos a brindar aqui." },
      { y: "2026", t: "O bar de sempre, finalmente em voz alta", d: "Hoje El gato con copas faz parte da família #PICHONTEAM, junto com La Patrona. Não é uma linha nova: é a de sempre. Abrimos a porta para que também tu encontres o teu antídoto." },
    ],
    quote: "Não viemos beber um copo. Viemos para ficar.",
    signature: "— Os de sempre, do balcão do gato",
    wink: "La Patrona diz «Não é só um evento, é uma experiência». No gato levamos isso a cada noite.",
  },
  carta: {
    eyebrow: "A carta",
    title: "Um conto em quatro capítulos",
    intro: "Cada noite lê-se de forma diferente, mas o conto começa sempre igual: algo bom para partilhar e um copo bem feito. Escolhe o capítulo.",
    chapters: {
      "primeras-lineas": "Para petiscar enquanto chega o resto. Os pratos com que começa qualquer boa história.",
      sirena: "O que vem do mar, fresco e com calma. Para quem se deixa levar pela maré.",
      cazador: "Sabores da terra, com carácter. Para quem vai com tudo.",
      postres: "O final doce. Porque toda a boa noite merece um final feliz.",
    },
    note: "Pergunta no balcão pelo antídoto da casa. Muda todas as noites, como deve ser.",
  },
  vision: {
    eyebrow: "Visão", title: "Para onde ronrona o gato", items: [
      { t: "O bar de sempre", d: "O sítio a que voltas sem combinar, porque sabes que haverá alguém conhecido no balcão." },
      { t: "Coquetelaria sem complexos", d: "Técnica de balcão a sério, trato de amigos de sempre." },
      { t: "Espírito tropical", d: "Plantas, cor e música para fugir sem sair da cidade." },
      { t: "Cada noite, uma experiência", d: "Nenhuma noite se repete. Cada celebração é única e cada cliente, mais um capítulo da história." },
    ],
  },
  servicios: {
    eyebrow: "A tua noite, à tua maneira",
    title: "Tu pões o motivo. Nós, a experiência.",
    intro: "Abre cada opção e conta-nos o que tens em mente.",
    items: {
      cumpleanos: "Mais um ano merece uma noite inesquecível. Zona reservada, cocktails para o grupo e a música que te apetecer. Tu só sopras as velas.",
      fiestas: "Despedidas, aniversários, jantares de empresa ou só porque sim. Desenhamos a noite contigo: carta, copos, ambiente e até ao último detalhe.",
      reservas: "O bar inteiro para os teus. Como em casa, mas com o melhor balcão da cidade.",
    },
    buttons: { cumpleanos: "Quero o meu aniversário aqui", fiestas: "Desenhar a minha festa", reservas: "Reservar o espaço" },
  },
  galeria: {
    eyebrow: "Galeria",
    title: "Noites reais, gente da casa",
    intro: "Nenhuma foto se repete, porque nenhuma noite se repete. Estas são algumas das vidas que o gato já viveu.",
  },
  form: {
    eyebrow: "Reserva a tua noite", title: "Conta-nos o teu plano",
    intro: "Diz-nos o que celebras e nós tratamos de que seja uma experiência. Respondemos em menos de 24 horas. Com pressa? Escreve-nos no WhatsApp.",
    name: "Nome completo", email: "Email", phone: "Telefone", service: "O que celebramos?", date: "Data prevista", guests: "Nº de pessoas", message: "Mensagem",
    messagePh: "Conta-nos a tua noite ideal…", choose: "Escolhe uma opção",
    options: { cumpleanos: "Aniversário", fiestas: "Festa privada", reservas: "Reservar o espaço", info: "Só quero informação" },
    submit: "Quero a minha experiência", sending: "A enviar...",
    ok: "Recebido! O gato já está a preparar a tua noite. Escrevemos-te em menos de 24 horas.",
    err: "Não foi possível enviar. Tenta de novo ou escreve-nos no WhatsApp.",
  },
  mapa: { eyebrow: "Arquitetura web", title: "Mapa do site, pronto para SEO", intro: "Estrutura hierárquica do site para otimizar o rastreio e a indexação. Passa o cursor por cada nó para ver o URL e o esquema." },
  footer: { tagline: "Cada noite, uma experiência.", explore: "Explorar", partners: "A família", hours: "[Horário]", rights: "Todos os direitos reservados.", design: "Design e estratégia", patrona: "Eventos" },
  whatsapp: "Olá, gostaria de receber mais informação sobre El gato con copas.",
};

export default pt;
